import { v4 as uuidv4 } from 'uuid';

/**
 *
 * @param prefix 접두사
 * @returns 접두사_uuid
 */
export default function generateUniqueId(prefix: string) {
  const uniqueId = uuidv4();
  return `${prefix}_${uniqueId}`;
}
